import React from 'react';
import {useSelector} from 'react-redux';
import {useFormikContext} from 'formik';

import {honorAwardsAndIssuersSelector} from 'src/redux/lists';
import {EducationPhase} from 'src/types/enums';
import {Store} from 'src/types/store';

import FormikTypeahead from 'src/components/formik-typeahead';
import FormikDatePicker from 'src/components/formik-date-picker';
import Label from 'shared/components/label';
import FormikTextArea from 'src/components/formik-text-area';
import {HonorAwardForm} from './honor-awards-form-wrapper';

const HonorAwardsForm = () => {
  const formik = useFormikContext<HonorAwardForm>();
  const educationPhase = useSelector((state: Store) => state.student?.educationPhase);
  const {awardOptions, issuerOptions} = useSelector(honorAwardsAndIssuersSelector);

  return (
    <>
      <legend className="shared-required-legend"></legend>

      <Label required>
        Award Name
        <FormikTypeahead
          id="honor-award-name-typeahead"
          name="name"
          placeholder={
            educationPhase === EducationPhase.HIGH_SCHOOL
              ? 'e.g. National Honor Society'
              : 'e.g. Phi Theta Kappa'
          }
          options={awardOptions}
          onSelect={(result) => {
            formik.setValues({
              ...formik.values,
              name: result.text,
              ...(issuerOptions[result.id] && {issuer: issuerOptions[result.id].text}),
            });
          }}
          required
        />
      </Label>

      <div className="portfolio-sections side-by-side">
        <Label required>
          Issuer
          <FormikTypeahead
            id="honor-award-issuer-typeahead"
            name="issuer"
            placeholder={
              educationPhase === EducationPhase.HIGH_SCHOOL
                ? 'e.g. National Honor Society (NHS)'
                : 'e.g. Phi Theta Kappa'
            }
            onSelect={(result) => formik.setFieldValue('issuer', result.text)}
            options={issuerOptions}
            required
          />
        </Label>

        <FormikDatePicker
          monthName="month"
          yearName="year"
          lastX={educationPhase === EducationPhase.HIGH_SCHOOL ? 6 : 30}
          required
        />
      </div>

      <Label>
        Description
        <FormikTextArea name="description" placeholder="Description..." />
      </Label>
    </>
  );
};

export default HonorAwardsForm;
